import { useEffect, useState } from "react";

// Grow week chosen in the irrigation section, shared with the hero animals (saved per browser).
const KEY = "jungle-grow-week";
const EVT = "jungle-grow-week";

export const readGrowWeek = () => {
  try { return localStorage.getItem(KEY); } catch { return null; }
};

export const saveGrowWeek = (week) => {
  try { localStorage.setItem(KEY, week); } catch { /* storage blocked */ }
  window.dispatchEvent(new CustomEvent(EVT, { detail: week }));
};

export const useGrowWeek = () => {
  const [week, setWeek] = useState(readGrowWeek);
  useEffect(() => {
    const on = (e) => setWeek(e.detail);
    window.addEventListener(EVT, on);
    return () => window.removeEventListener(EVT, on);
  }, []);
  return week;
};

export const weekLabel = (c) => (c?.startsWith("C") ? `Crecimiento S${c.slice(1)}` : c === "F8" ? "Lavado" : `Floración S${c?.slice(1)}`);
